import { Organizable } from './Organizable';

const compute = <T extends Iterable<Organizable>>(plots: T, spacing = 20): T => {

    const arr = Array.from(plots);
    const sz = Math.ceil(Math.sqrt(arr.length));
    const cw = Math.max(...arr.map(x => x.width())) + spacing;
    const ch = Math.max(...arr.map(x => x.height())) + spacing;

    let i = 0;
    for (const p of plots) {
        const x = i % sz;
        const y = Math.floor(i / sz);
        p.moveTo(x * cw, y * ch);
        i++;
    }

    return plots;
};

export const GridLayout = { compute };
